import React, { useRef, useState } from 'react';
import moment from 'moment';
import ScheduleItemsDetails from './ScheduleItemsDetails';
import { ReactComponent as DownArrow } from '../../../../../resources/images/svg/downArrow.svg';

function ScheduleListItem({ schedule, containerWidth, stationsMap }) {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef(null);

  const handleExpand = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div>
      <div className="w-full flex gap-1 items-center text-center" ref={ref}>
        <div
          className="flex items-center flex-1 sticky left-0 bg-gray-light-gr min-h-8 z-10 justify-center"
          style={{ height: ref?.current?.clientHeight }}
        >
          <p className="text-base m-0 py-2">{schedule?.rideNumber}</p>
        </div>
        <p className="text-base m-0 flex-[2] capitalize">
          {stationsMap.get(schedule?.startStation?.code) || schedule?.startStation?.name}
          {' '}
          –
          {' '}
          {stationsMap.get(schedule?.endStation?.code) || schedule?.endStation?.name}
        </p>

        <div className="flex-1 flex justify-center">
          <button
            type="button"
            onClick={handleExpand}
            className="flex justify-between items-center gap-3 px-[14px] h-8 border-transparent bg-white rounded-2xl cursor-pointer w-[80px]"
          >
            <p className="text-base m-0 ">
              {schedule?.numberOfStandinStation || 0}
            </p>
            <div className="h-full pt-1">
              <DownArrow className={`w-[14px] h-[14px] ease-out duration-300 ${expanded && 'rotate-[270deg]'}`} />
            </div>
          </button>
        </div>
        <p className="text-base m-0 flex-1">
          {moment(schedule?.startDate).format('HH:mm')}
        </p>
        <p className="text-base m-0 flex-1">
          {moment(schedule?.endDate).format('HH:mm')}
        </p>
      </div>
      <ScheduleItemsDetails
        containerWidth={containerWidth}
        expanded={expanded}
        stationsMap={stationsMap}
        scheduleId={schedule.rideId}
      />
      <div className="w-full h-[2px] bg-white mt-[13px]" />
    </div>
  );
}

export default ScheduleListItem;
